import { createContext } from "react"
import type { Dispatch } from "react"
import type { Layout } from "react-grid-layout"
import type { StaticPlotDef, QueryPlotDef } from "types/dashboard.types"
import type { EntityType } from "types/common.types"

export interface DashboardContextValue {
  config: {
    type: string
    plotDefs: (StaticPlotDef | QueryPlotDef)[]
  }
  plotLayout?: Record<string, Layout>
  dispatchPlotLayout?: Dispatch<any>
  entityType: EntityType
  rowHeight?: number
}

const DashboardContext = createContext<DashboardContextValue | null>(null)

export default DashboardContext
